import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { ListItem } from './styles'
import { Color, TextVariant } from 'styles/types'

interface ListProps {
    children: (JSX.Element | undefined)[]
    variant?: TextVariant
    color?: Color
    gap?: number | [number, number]
    isBulletCentered?: boolean
}

const List = ({
    children,
    variant,
    color,
    gap,
    isBulletCentered,
}: ListProps) => (
    <Box gap={gap} as="ul">
        {children
            .filter((child) => child !== undefined)
            .map((child, index) => (
                <ListItem
                    gap={12}
                    direction="row"
                    align="center"
                    backgroundColor={color}
                    isBulletCentered={isBulletCentered}
                    as="li"
                    key={index}
                >
                    <Text
                        variant={variant ?? 'body'}
                        color={color ?? 'grayscale_900'}
                    >
                        {child}
                    </Text>
                </ListItem>
            ))}
    </Box>
)

export default List
